export const LANGUAGES = [
    {
        id: 0,
        name: "Chinese",
        image: "/images/languages/china.png"
    },
    {
        id: 1,
        name: "French",
        image: "/images/languages/france.png"
    },
    {
        id: 2,
        name: "German",
        image: "/images/languages/germany.png"
    },
    {
        id: 3,
        name: "Italy",
        image: "/images/languages/italy.png"
    },
    {
        id: 4,
        name: "Korean",
        image: "/images/languages/south-korea.png"
    },
    {
        id: 5,
        name: "Swedish",
        image: "/images/languages/sweden.png"
    },
    {
        id: 6,
        name: "Greece",
        image: "/images/languages/greece.png"
    },
    {
        id: 7,
        name: "Japan",
        image: "/images/languages/japan.png"
    },
    {
        id: 8,
        name: "Indian",
        image: "/images/languages/india.png"
    },
    {
        id: 9,
        name: "Turkish",
        image: "/images/languages/turkey.png"
    },
    {
        id: 10,
        name: "Nigerian",
        image: "/images/languages/nigeria.png"
    },
    {
        id: 11,
        name: "Austrian",
        image: "/images/languages/austria.png"
    }
];
